// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3AKzY","gfeWrapper":"CalendarEvent_gfeWrapper__2ML8T"};